/* Слабый телефон (владелец 02.11.2026: «каждая анимация — 60 кадров на любом телефоне»): html.lowfx снимает самые дорогие для видеочипа эффекты —
   размытие фона под стеклом (backdrop-filter: меню, островок, таблетка в чёлке, подсказки, плашки на картинках) и размытые свечения карточек
   (low-fx.css). Размытие пересчитывается каждый кадр, пока под стеклом что-то движется (прокрутка под меню, анимация островка), и на слабом
   видеочипе именно оно съедает кадр. Стекло без размытия становится плотнее (подложка --lg-tint3), чтобы текст читался так же.
   Кто слабый: Telegram на Android сам пишет класс устройства в конец user-agent («…; SDK 33; LOW)»); его нет (iOS, браузер) — по памяти
   (navigator.deviceMemory ≤ 3 ГБ) или ядрам (≤ 4). Ручной переключатель для проверки: localStorage steos.lowfx = '1' | '0'. */
import './low-fx.css';

/** Класс устройства от Telegram для Android: LOW | AVERAGE | HIGH; нет — null */
export function tgPerformanceClass(ua: string): 'LOW' | 'AVERAGE' | 'HIGH' | null {
  const m = /Telegram-Android\/[^(]*\([^)]*;\s*(LOW|AVERAGE|HIGH)\s*\)/i.exec(ua);
  return m ? (m[1].toUpperCase() as 'LOW' | 'AVERAGE' | 'HIGH') : null;
}

/** Слабое устройство: класс Telegram LOW, без класса — мало памяти или ядер */
export function isLowEnd(nav: { userAgent: string; hardwareConcurrency?: number; deviceMemory?: number }): boolean {
  const cls = tgPerformanceClass(nav.userAgent || '');
  if (cls) return cls === 'LOW';
  const mem = nav.deviceMemory,
    cores = nav.hardwareConcurrency;
  return (!!mem && mem <= 3) || (!!cores && cores <= 4);
}

export function installLowFx(root: HTMLElement = document.documentElement) {
  let force: string | null = null;
  try {
    force = localStorage.getItem('steos.lowfx');
  } catch {
    /* хранилище недоступно — решает устройство */
  }
  const on = force === '1' ? true : force === '0' ? false : isLowEnd(navigator as Navigator & { deviceMemory?: number });
  root.classList.toggle('lowfx', on);
  return on;
}
